import { combineReducers } from 'redux';
import { socialmedia, socialmediaDE, socialmediaES, socialmediaFR, socialmediaPT, socialmediaHI, socialmediaINDO, socialmediaRU, socialmediaCH, socialmediaJP, socialmediaAR, socialmediaIT, socialmediaTR, socialmediaNL, socialmediaGR} from './socialmedia.reducer';
import { account } from './account.reducer';
import { menuswitch } from './switch.reducer';
import { languageswitch } from './languageswitch.reducer';
import { breach } from './breach.reducer';
import { news } from './news.reducer';
import { quote } from './quote.reducer';
import { quoteswitch } from './quoteswitch.reducer';
import { themeswitch } from './themeswitch.reducer';

const rootReducer = combineReducers({
  socialmedia,
  socialmediaDE,
  socialmediaES,
  socialmediaFR,
  socialmediaPT,
  socialmediaHI,
  socialmediaINDO,
  socialmediaRU,
  socialmediaCH,
  socialmediaJP,
  socialmediaAR,
  socialmediaIT,
  socialmediaTR,
  socialmediaNL,
  socialmediaGR,
  account,
  menuswitch,
  languageswitch,
  breach,
  news,
  quote,
  quoteswitch,
  themeswitch,
});

export default rootReducer;